import React from 'react';

export default function ActionButton({ icon, altText="", clickHandler }) {
  return (
    <div className="action-item cursor-pointer" onClick={clickHandler}>
      <img src={icon} alt={altText}/>
    </div>
  );
}